import PublishingAtAGlancePreferences from './publishingAtAGlancePreferences.component';
angular.module('HomepageServices').component('publishingAtAGlancePreferences', PublishingAtAGlancePreferences);


// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlancePreferences/index.js